import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'

type DateFormLib = {
  dateWithoutTime: (date: Date | string | null | undefined) => number | string
  getToday: () => Date
  getTommorow: () => Date
}

type GlobalVarWithPayments = {
  in_app_payments?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoCreateDateCard',
  props: {
    currentCardId: null,
    formatId: null,
    showQuickEmailBanner: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { currentCardId?: string, formatId?: string, showQuickEmailBanner: boolean };



const { formLib: formLibRaw, globalVar } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & DateFormLib
const formatData = useRirekishoFormatData()

/**
 * 作成日は書式によって独立ステップではなく確認画面に置かれる
 * （カード定義の `sections`）。
 */
const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

/** 作成日が独立ステップか（確認画面に取り込まれていないか） */
const isOwnStep = computed(() => props.currentCardId === 'create-date')

const showBanner = computed(
  () =>
    isOwnStep.value &&
    props.showQuickEmailBanner &&
    !!(globalVar as typeof globalVar & GlobalVarWithPayments).in_app_payments
)

const isTodaySelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getToday())
)

const isTomorrowSelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getTommorow())
)

function setToday() {
  formatData.createDate = formLib.getToday()
}

function setTomorrow() {
  formatData.createDate = formLib.getTommorow()
}

return { __sfc: true,props, formLibRaw, globalVar, formLib, formatData, isSection, isOwnStep, showBanner, isTodaySelected, isTomorrowSelected, setToday, setTomorrow }
}

})